import { CheckCircle, Cog, Sparkles } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import logoImage from "@/assets/greenvision-logo.png";

export default function ExternalIntakeSuccess() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-[#014336] via-[#014336]/90 to-[#016d56] flex flex-col items-center justify-center p-4 relative overflow-hidden">
      {/* Background decorative elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-white/5 rounded-full blur-3xl" />
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-white/5 rounded-full blur-3xl" />
      </div>

      {/* Logo */}
      <img 
        src={logoImage} 
        alt="GreenVision Energy" 
        className="h-10 sm:h-12 mb-8 brightness-0 invert opacity-90"
      />
      
      {/* Success Card */}
      <Card className="w-full max-w-xl text-center bg-white/95 backdrop-blur-sm shadow-2xl border-0 relative z-10">
        <CardHeader className="pb-4">
          {/* Animated Success Icon */}
          <div className="mx-auto mb-6 relative">
            {/* Pulsing ring */}
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="h-24 w-24 rounded-full border-4 border-[#014336]/20 animate-success-ring" />
            </div>
            {/* Main icon */}
            <div className="h-20 w-20 flex items-center justify-center rounded-full bg-gradient-to-br from-[#014336] to-[#016d56] shadow-lg mx-auto">
              <CheckCircle className="h-10 w-10 text-white opacity-0 animate-success-check" />
            </div>
          </div>
          
          <CardTitle className="text-2xl sm:text-3xl text-[#014336]">
            Intake verzonden!
          </CardTitle>
          <CardDescription className="text-base mt-3 max-w-md mx-auto">
            Bedankt voor het invullen van de technische intake. We hebben alle gegevens ontvangen en nemen contact op als we nog vragen hebben.
          </CardDescription>
        </CardHeader>
        
        <CardContent className="space-y-6 pb-8">
          {/* "We're on it" animated section */}
          <div className="flex items-center justify-center gap-3 text-[#014336] bg-[#014336]/5 py-3 px-4 rounded-lg">
            <Cog className="h-5 w-5 animate-spin-slow" />
            <span className="font-medium">We gaan aan de slag met je gegevens</span>
            <Sparkles className="h-4 w-4" />
          </div>
          
          {/* Bouncing dots */}
          <div className="flex justify-center gap-2">
            <span className="h-2.5 w-2.5 rounded-full bg-[#014336] animate-bounce-dot-1" />
            <span className="h-2.5 w-2.5 rounded-full bg-[#014336]/80 animate-bounce-dot-2" />
            <span className="h-2.5 w-2.5 rounded-full bg-[#014336]/60 animate-bounce-dot-3" />
          </div>
          
          <p className="text-sm text-muted-foreground pt-2">
            Je kunt dit tabblad nu sluiten.
          </p>
        </CardContent>
      </Card>

      {/* Footer branding */}
      <p className="text-white/60 text-sm mt-8">
        Developing a Sustainable Future
      </p>
    </div>
  );
}
